'use strict'

domConfig = require './dom_config'
{omitUndefined} = require '../../helpers/underscore_replacement'

module.exports =
  PARAMS_BLACKLIST: [ "page" , "post_filters"]
  AVAILABLE_FACET_NAMES: ["city", "neighborhood", "hotelAvailability", "category2", "category3", "category4", "brand", "price", "datetime", "age", "groups", "seasons", "indoor_outdoor", "badge", 'groupon_plus', 'shipping_pickup', 'distance', 'rating', 'delivery_pickup']

  updateParams: (selectedRefinements, isRefinementUpdated) ->
    queryParams = _getFacetsFromUrl(selectedRefinements, @PARAMS_BLACKLIST, @AVAILABLE_FACET_NAMES)
    enabledFacets = _getEnabledFacets(selectedRefinements, queryParams)

    builtParams =
      category: _buildRefinementParam _getCategory(enabledFacets.category)
      category2: _buildRefinementParam _getCategory2(enabledFacets)
      category3: _buildRefinementParam enabledFacets.category3
      category4: _buildRefinementParam enabledFacets.category4
      brand: _buildRefinementParam enabledFacets.brand
      price: _buildRefinementParam enabledFacets.price
      age: _buildRefinementParam enabledFacets.age
      groups: _buildRefinementParam enabledFacets.groups
      badge: _buildRefinementParam enabledFacets.badge
      seasons: _buildRefinementParam enabledFacets.seasons
      indoor_outdoor: _buildRefinementParam enabledFacets.indoor_outdoor
      groupon_plus: _buildRefinementParam enabledFacets.groupon_plus
      shipping_pickup: _buildRefinementParam enabledFacets.shipping_pickup
      distance: _buildRefinementParam enabledFacets.distance
      rating: _buildRefinementParam enabledFacets.rating
      delivery_pickup: _buildRefinementParam enabledFacets.delivery_pickup
      bbox: _buildRefinementParam enabledFacets.bbox?.split(',')
      radius_km: _buildRefinementParam enabledFacets.radius_km
      city: _buildRefinementParam enabledFacets.city
      neighborhood: _buildRefinementParam enabledFacets.neighborhood

    updatedParams = Object.assign({}, builtParams, queryParams)

    if selectedValues = enabledFacets.sort?.selectedValues
      # This case happens when the `Sort By` is a Featured filter in the local page
      updatedParams.sort = selectedValues[0]?.name

    if queries = enabledFacets.search
      updatedParams.query = _buildRefinementParam queries

    if rangeFilter = enabledFacets.rangeFilter
      Object.assign updatedParams, _buildRangeFilterParam(rangeFilter)

    if dateTimeFilter = enabledFacets.datetime
      Object.assign updatedParams, _buildDateTimeFilterParam(dateTimeFilter)

    if calendarFilter = enabledFacets.hotelAvailability
      Object.assign updatedParams, _buildCalendarFilterParam(calendarFilter)

    if builtParams.bbox
      Object.assign updatedParams, { bbox: builtParams.bbox }

    if builtParams.radius_km
      Object.assign updatedParams, { radius_km: builtParams.radius_km }

    if domConfig.get()?.showFilters
      _buildFiltersParams updatedParams, selectedRefinements

    omitUndefined updatedParams

  buildCalendarFilterParam: (selected) ->
    _buildCalendarFilterParam selected

_buildDateTimeFilterParam = ({selectedValues}) ->
  date = ''
  time = ''
  selectedValues.forEach((refinement) ->
    if refinement.name == 'date'
      date = refinement.refinementId
    if refinement.name == 'time'
      time = refinement.refinementId
  )
  date = if date is "anyday" then '' else date
  time = if time is "anytime" then '' else time

  return unless date or time
  {datetime: "#{date}:#{time}"}

_buildCalendarFilterParam = (selectedVal) ->
  return hotelAvailability: "" unless selectedVal?[0]?

  selectedValues = selectedVal[0]

  return hotelAvailability: "" unless selectedValues?.checkinDate? and selectedValues?.checkoutDate?

  hotelAvailability: "[#{selectedValues.checkinDate}..#{selectedValues.checkoutDate}]"

_getEnabledFacets = (selectedRefinements, queryParams) ->
  topcategoryInURL = queryParams?.topcategory

  category: _getNestedRefinements(selectedRefinements.category, "category", [], topcategoryInURL)
  category2: _getNestedRefinements(selectedRefinements.category, "category2")
  category3: _getNestedRefinements(selectedRefinements.category, "category3")
  category4: _getNestedRefinements(selectedRefinements.category, "category4")
  # location: _getSelectedRefinements(selectedRefinements.location)
  search: _getSearchRefinement(selectedRefinements.search)
  rangeFilter: selectedRefinements.rangeFilters
  price: _getSelectedRefinements(selectedRefinements.price)
  brand: _getSelectedRefinements(selectedRefinements.brand)
  sort: selectedRefinements.sort
  datetime: selectedRefinements.datetime
  age: _getNestedRefinements(selectedRefinements.age, "age")
  groups: _getSelectedRefinements(selectedRefinements.groups)
  badge: _getSelectedRefinements(selectedRefinements.badge)
  seasons: _getSelectedRefinements(selectedRefinements.seasons)
  indoor_outdoor: _getSelectedRefinements(selectedRefinements.indoor_outdoor)
  groupon_plus: _getSelectedRefinements(selectedRefinements.groupon_plus)
  hotelAvailability: selectedRefinements.calendar?.selectedValues
  shipping_pickup: _getSelectedRefinements(selectedRefinements.shipping_pickup)
  distance: _getSelectedRefinements(selectedRefinements.distance)
  rating: _getSelectedRefinements(selectedRefinements.rating)
  delivery_pickup: _getSelectedRefinements(selectedRefinements.delivery_pickup)
  bbox: selectedRefinements.bbox
  radius_km: selectedRefinements.radius_km
  city: _getSelectedCityRefinements(selectedRefinements.location)
  neighborhood: _getSelectedNeighborhoodRefinements(selectedRefinements.location)

_getFacetsFromUrl = (selectedRefinements, paramsBlacklist, availableFacetNames) ->
  availableFacetNames.push('query') if selectedRefinements.hasOwnProperty('search')

  unparam = Groupon.Utils.unparam()

  predicate = (key) -> availableFacetNames.concat(paramsBlacklist).indexOf(key) == -1

  tmpUnparam = {}
  Object.keys(unparam).filter(predicate).forEach (key) ->
    tmpUnparam[key] = unparam[key]
  unparam = tmpUnparam

_getSelectedRefinements = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length

  selectedRefinement.selectedValues.map (value) ->
    value.name

_getSelectedCityRefinements = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length

  {selectedValues} = selectedRefinement
  cities = selectedValues.filter (value) -> value.type is 'city'
  return unless cities.length

  cities.map (city) ->
    city.name

_getSelectedNeighborhoodRefinements = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length

  {selectedValues} = selectedRefinement
  neighborhoods = selectedValues.filter (value) -> value.type is 'neighborhood'
  return unless neighborhoods.length

  neighborhoods.map (neighborhood) ->
    neighborhood.name

_getSearchRefinement = (selectedRefinement) ->
  return unless selectedRefinement?.selectedValues.length
  selectedRefinement.selectedValues.map (value) ->
    value.friendlyName

_getNestedRefinements = (selectedRefinement, key, refinementNames = [], topcategoryInURL = null) ->
  return [] unless selectedRefinement?.selectedValues?.length
  selectedRefinements = selectedRefinement.selectedValues

  selectedRefinements.forEach (refinement) ->
    if refinement.id is key and refinement.name != topcategoryInURL
      refinementNames.push refinement.name
    else
      _getNestedRefinements(refinement, key, refinementNames)

  refinementNames

_buildRefinementParam = (param) ->
  return unless param?.length > 0
  param.join(',')

_buildFiltersParams = (updatedParams, selectedRefinements) ->
  for key, value of selectedRefinements
    if domConfig.get().filters?[key]?
      selectedFilterRefinement = _getSelectedRefinements value
      updatedParams[key] = _buildRefinementParam selectedFilterRefinement

_buildRangeFilterParam = (selectedRefinement) ->
  param = selectedRefinement.selectedValues?[0]

  minPrice: param?.selectedMin
  maxPrice: param?.selectedMax

_getCategory = (category) ->
  return if category[0] is "local"
  category

_getCategory2 = (enabledFacets) ->
  return [] if enabledFacets["category3"].length

  enabledFacets["category2"]
